import { SingleSpaAppStatus } from "../types/singleSpa.types";
import {
	triggerRouteChangeSpaEvent,
	triggerRouteChangeSpaMountEvent,
	triggerSaveProductListState,
	triggerWishlistUnmountedEvent,
	triggerCartUnmountedEvent,
	updateCanonicalMetaTag,
} from "./routerActions";
import { isScrollTop, isValidRouterNavigation, shouldFocusFirstElement } from "./utils";
import { resetLastOrchestratorNavigatedUrl } from "./routerLinks";
import { isMinifiedHeaderCartEnabled } from "@ocm/services/ocm-object";

const spaLoadingElement = document.getElementById("js-spa-loading");
const hideLoading = (): void => {
	if (spaLoadingElement) {
		spaLoadingElement.style.display = "none";
	}
};
const showLoading = (): void => {
	if (spaLoadingElement) {
		spaLoadingElement.style.display = "";
	}
};

const firstElement = document.querySelector<HTMLElement>("#js-first-element");
window.addEventListener("single-spa:routing-event", ({ detail }) => {
	if (isValidRouterNavigation(detail)) {
		triggerRouteChangeSpaEvent(detail.newUrl);
		updateCanonicalMetaTag();
		if (shouldFocusFirstElement(detail)) firstElement?.focus();
	}

	if (isScrollTop(detail)) {
		scrollTo(0, 0);
	}
	resetLastOrchestratorNavigatedUrl();
	if (detail.newAppStatuses["mf-cart"] === SingleSpaAppStatus.MOUNTED) {
		const offset = (isMinifiedHeaderCartEnabled && document.querySelector("#js-header")?.clientHeight) || 0;
		window.scrollTo({ top: offset });
	}
});

window.addEventListener("single-spa:before-routing-event", ({ detail }) => {
	if (isValidRouterNavigation(detail)) {
		const _inertElements = document.querySelectorAll<HTMLElement>("[inert]");
		_inertElements.forEach((el) => {
			el.removeAttribute("inert");
		});

		if (detail.newAppStatuses["mf-productlist"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerSaveProductListState(detail.oldUrl);
		}
		if (detail.newAppStatuses["mf-wishlist"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerWishlistUnmountedEvent();
		}
		if (detail.newAppStatuses["mf-cart"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerCartUnmountedEvent();
		}
	}
});

window.addEventListener("single-spa:before-app-change", () => {
	showLoading();
});

window.addEventListener("single-spa:app-change", ({ detail }) => {
	hideLoading();
	if (isValidRouterNavigation(detail)) {
		triggerRouteChangeSpaMountEvent(detail.appsByNewStatus[SingleSpaAppStatus.MOUNTED], detail.newUrl);
	}
});

window.addEventListener("single-spa:before-first-mount", () => {
	hideLoading();
});
